import {
  FETCH_SENGAGE_DATA_INIT,
  FETCH_SENGAGE_DATA_SUCCESS,
  FETCH_SENGAGE_DATA_FAIL,
  FETCH_SENGAGE_TIMELINE_DATA_INIT,
  FETCH_SENGAGE_TIMELINE_DATA_SUCCESS,
  FETCH_SENGAGE_TIMELINE_DATA_FAIL,
  FETCH_SENGAGE_CAMPAIGN_FRAMES_INIT,
  FETCH_SENGAGE_CAMPAIGN_FRAMES_SUCCESS,
  FETCH_SENGAGE_CAMPAIGN_FRAMES_FAIL,
  FETCH_TIMING_PATTERNS_INIT,
  FETCH_TIMING_PATTERNS_SUCCESS,
  FETCH_TIMING_PATTERNS_FAIL,
  FETCH_OUTLET_RANKING_INIT,
  FETCH_OUTLET_RANKING_SUCCESS,
  FETCH_OUTLET_RANKING_FAIL,
  FETCH_PROMO_MECHANICS_INIT,
  FETCH_PROMO_MECHANICS_SUCCESS,
  FETCH_PROMO_MECHANICS_FAIL,
} from './constants';

export const fetchSmartEngageData = payload => ({
  type: FETCH_SENGAGE_DATA_INIT,
  payload,
});

export const fetchSmartEngageSuccess = data => ({
  type: FETCH_SENGAGE_DATA_SUCCESS,
  payload: data,
});

export const fetchSmartEngageFailure = error => ({
  type: FETCH_SENGAGE_DATA_FAIL,
  error: error.message,
});

export const fetchSmartEngageTimelineData = payload => ({
  type: FETCH_SENGAGE_TIMELINE_DATA_INIT,
  payload,
});

export const fetchSmartEngageTimelineSuccess = data => ({
  type: FETCH_SENGAGE_TIMELINE_DATA_SUCCESS,
  payload: data,
});

export const fetchSmartEngageTimelineFailure = error => ({
  type: FETCH_SENGAGE_TIMELINE_DATA_FAIL,
  error: error.message,
});

export const fetchSmartEngageCampaignFrames = payload => ({
  type: FETCH_SENGAGE_CAMPAIGN_FRAMES_INIT,
  payload,
});

export const fetchSmartEngageCampaignFramesSuccess = data => ({
  type: FETCH_SENGAGE_CAMPAIGN_FRAMES_SUCCESS,
  payload: data,
});

export const fetchSmartEngageCampaignFramesFailure = error => ({
  type: FETCH_SENGAGE_CAMPAIGN_FRAMES_FAIL,
  error: error.message,
});

export const fetchTimingPatterns = payload => ({
  type: FETCH_TIMING_PATTERNS_INIT,
  payload,
});

export const fetchTimingPatternsSuccess = data => ({
  type: FETCH_TIMING_PATTERNS_SUCCESS,
  payload: data,
});

// errorMessage is a pre-formatted string from the saga (HTTP code, network, or API-level message)
export const fetchTimingPatternsFailure = errorMessage => ({
  type: FETCH_TIMING_PATTERNS_FAIL,
  error: errorMessage,
});

export const fetchOutletRanking = payload => ({
  type: FETCH_OUTLET_RANKING_INIT,
  payload,
});

export const fetchOutletRankingSuccess = data => ({
  type: FETCH_OUTLET_RANKING_SUCCESS,
  payload: data,
});

export const fetchOutletRankingFailure = errorMessage => ({
  type: FETCH_OUTLET_RANKING_FAIL,
  error: errorMessage,
});

export const fetchPromoMechanics = payload => ({
  type: FETCH_PROMO_MECHANICS_INIT,
  payload,
});

export const fetchPromoMechanicsSuccess = data => ({
  type: FETCH_PROMO_MECHANICS_SUCCESS,
  payload: data,
});

export const fetchPromoMechanicsFailure = errorMessage => ({
  type: FETCH_PROMO_MECHANICS_FAIL,
  error: errorMessage,
});
